// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_fk4cZ {
  width: 400px;
  height : 400px;
  position : relative;
}

.area_ki4lY {
  padding : 0 var( --size-padLarge, 16px );
}

.footer_Rbb4i {
  padding : var( --size-padLarge, 16px );
  display : grid;
  justify-content: center;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  column-gap: var( --size-padMedium, 8px );
}
`, "",{"version":3,"sources":["webpack://./src/screens/clientId/AddDialog.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;AAC1C","sourcesContent":[".dialog {\n  width: 400px;\n  height : 400px;\n  position : relative;\n}\n\n.area {\n  padding : 0 var( --size-padLarge, 16px );\n}\n\n.footer {\n  padding : var( --size-padLarge, 16px );\n  display : grid;\n  justify-content: center;\n  align-items: center;\n  grid-template-columns: 1fr 1fr;\n  column-gap: var( --size-padMedium, 8px );\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `dialog_fk4cZ`,
	"area": `area_ki4lY`,
	"footer": `footer_Rbb4i`
};
export default ___CSS_LOADER_EXPORT___;
